"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on 26.04.2019
*/

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Supplier Order suggested header converter.
 *
 * @author ZSr
 */


var SupplierOrderSuggestedHeaderConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SupplierOrderSuggestedHeaderConverter, _DataObjectConverter_);

  function SupplierOrderSuggestedHeaderConverter() {
    _classCallCheck(this, SupplierOrderSuggestedHeaderConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierOrderSuggestedHeaderConverter).apply(this, arguments));
  }

  return SupplierOrderSuggestedHeaderConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SupplierOrderSuggestedHeaderConverter = SupplierOrderSuggestedHeaderConverter;